import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Box } from '@h2/components/layout/box'
import { SDB, SDR, SO, SG, PB } from '@h2/components/colors'

import { base } from '../../mixins'

const colors = {
  blue: SDB,
  red: SDR,
  orange: SO,
  green: SG,
  monochrome: PB
}
const Wrap = styled(Box)`
  display: flex;
  flex-direction: column;
  ${base}
  border: ${({ color }) => `2px solid ${colors[color]}`};
  border-radius: 5px;
  background-image: ${({ color, bgColor }) =>
    `radial-gradient(circle at left bottom, ${bgColor}, ${bgColor} 79.9%, ${colors[color]} 80%)`};
  position: relative;
`
/**
 * The PromotionBox component.
 */
const PromotionBox = ({
  children,
  color = 'monochrome',
  bgColor = 'transparent',
  ...rest
}) => {
  return (
    <Wrap color={color} bgColor={bgColor} {...rest}>
      {children}
    </Wrap>
  )
}

export { PromotionBox }

PromotionBox.propTypes = {
  /** Sets the border color. */
  color: PropTypes.oneOf(['green', 'red', 'blue', 'orange', 'monochrome']),
  /** Sets the background color. */
  bgColor: PropTypes.string
}
